import { CompanyInfo, ServiceStats, NavItem } from '../types';

export const companyInfo: CompanyInfo = {
  name: "MiJin Technology Co., Ltd.",
  slogan: "Leading Smart Library Innovation with Technology & Service",
  description: "MiJin Technology focuses on library services, creating a smart library service ecosystem through technological and service innovation to promote universal reading.",
  email: "rfidlib@libmj.com",
  phone: "400-996-7738",
  address: "Shenzhen, Guangdong, China",
  founded: "2015",
  employees: "100+"
};

export const serviceStats: ServiceStats = {
  partners: "3389+",
  libraries: "32",
  readers: "2.3M+"
};

export const navigationItems: NavItem[] = [
  {
    label: "Home",
    href: "/"
  },
  {
    label: "System Services",
    href: "/products",
    children: [
      { label: "Library Cluster Management System", href: "/products" },
      { label: "Label Conversion System", href: "/products" },
      { label: "OPAC Search System", href: "/products" },
      { label: "Self-Service Circulation System", href: "/products" },
      { label: "Library Data Visualization", href: "/products" },
      { label: "RFID Inventory System", href: "/products" },
      { label: "Access Control & Alarm System", href: "/products" },
      { label: "WeChat Library", href: "/products" },
      { label: "RFID Terminal Management", href: "/products" }
    ]
  },
  {
    label: "Products",
    href: "/products",
    children: [
      { label: "Software Systems", href: "/products" },
      { label: "Staff Workstations", href: "/products" },
      { label: "Self-Service Circulation", href: "/products" },
      { label: "Self-Service Registration", href: "/products" },
      { label: "Security Gates", href: "/products" },
      { label: "Book Inventory", href: "/products" },
      { label: "Smart Book Lockers", href: "/products" },
      { label: "Digital Resources", href: "/products" }
    ]
  },
  {
    label: "Solutions",
    href: "/solutions",
    children: [
      { label: "AI Smart Visual Inventory", href: "/solutions" },
      { label: "K-12 Smart Libraries", href: "/solutions" },
      { label: "University Library Program", href: "/solutions" },
      { label: "Corporate Reading Spaces", href: "/solutions" },
      { label: "Urban Reading Rooms", href: "/solutions" },
      { label: "Public Libraries", href: "/solutions" }
    ]
  },
  {
    label: "Case Studies",
    href: "/cases"
  },
  {
    label: "News & Insights",
    href: "/news"
  },
  {
    label: "About Us",
    href: "/about"
  }
]; 